import { createAttachmentsApi } from '#/api/platform/attachments';

export const salesOrderAttachmentsApi = createAttachmentsApi(
  (businessId) => `/crm/sales-order/${businessId}/attachments`,
);
